import React from "react";
import { MapPin, Check, AlertCircle } from "lucide-react";
import { DESTINATIONS } from "../mock";

const Destinations = () => {
  return (
    <section id="destinations" className="py-14 md:py-24 bg-[#0b1220]">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center text-red-400 text-[11.5px] tracking-[0.22em] uppercase font-medium">
          Where can I study
        </div>
        <h2 className="mt-3 text-center text-white text-[34px] md:text-[44px] font-semibold leading-[1.1] tracking-tight">
          Three world-class destinations,
          <br className="hidden md:block" />
          <span className="text-amber-400"> one offer</span>
        </h2>
        <p className="mt-4 text-center text-slate-300 max-w-2xl mx-auto">
          Pick your dream destination. We handle the rest — free of charge, end to end.
        </p>

        <div className="mt-12 grid md:grid-cols-3 gap-5 md:gap-6">
          {DESTINATIONS.map((d) => (
            <div
              key={d.name}
              className="group relative overflow-hidden rounded-2xl cc-card transition-transform duration-300 hover:-translate-y-1"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={d.image}
                  alt={d.name}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0e1626] via-[#0e1626]/30 to-transparent" />
                <div className="absolute top-3 left-3 inline-flex items-center gap-1.5 rounded-full bg-black/45 backdrop-blur px-2.5 py-1 text-[11.5px] text-white border border-white/10">
                  <MapPin className="h-3.5 w-3.5" /> Study Destination
                </div>
              </div>
              <div className="p-6">
                <div className="flex items-center gap-2">
                  <span className="text-2xl leading-none">{d.flag}</span>
                  <h3 className="text-white text-[20px] font-semibold">{d.name}</h3>
                </div>
                <p className="mt-1.5 text-amber-300 text-[13.5px]">{d.tagline}</p>
                <ul className="mt-5 space-y-2.5">
                  {d.perks.map((p) => (
                    <li key={p} className="flex items-center gap-2.5 text-slate-200 text-[14px]">
                      <Check className="h-4 w-4 text-emerald-400" />
                      {p}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 rounded-2xl border border-white/10 bg-white/[0.03] p-4 md:p-5 flex items-start gap-3">
          <AlertCircle className="h-5 w-5 text-amber-400 mt-0.5 flex-shrink-0" />
          <p className="text-slate-300 text-[14.5px] leading-relaxed">
            <span className="text-white font-medium">Going to Canada?</span>{" "}
            Canada is not eligible under this promotion. We run a separate Canada-specific offer — just ask our team on WhatsApp.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Destinations;
